import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { withPolaris } from 'Components/protons/Polaris';

import { AnimatedChevrons } from 'Components/atoms/AnimatedChevrons';
import { Button } from 'Components/atoms/Button';
import { Image } from 'Components/atoms/Image';

import './_style.scss';

export const getRedirectLinkWithVRM = (redirectLink) => {
  let vrmFromParams = null;

  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    vrmFromParams = params.get('vrm');
  }

  return vrmFromParams ? `${redirectLink}${vrmFromParams}` : redirectLink;
};

export const addTracking = (gaTracking, clickedButton) => {
  if (typeof gaTracking.event === 'undefined') return;

  const trackingKvps = {
    event: gaTracking.event,
    button_text: clickedButton ? 'Continue' : 'Null',
  };

  if (gaTracking?.kvps?.length > 0) {
    gaTracking.kvps.forEach((kvp) => {
      trackingKvps[kvp.key] = kvp.value;
    });
  }

  window.dataLayer.push({
    ...trackingKvps,
  });
};

export const redirectPage = (redirectToLink) => {
  window.location.href = redirectToLink;
};

const IntermediaryPage = ({
  context: {
    cssPrefix,
  },
  desc,
  partnerLogo,
  redirectText,
  redirectLink,
  redirectTimeSecs,
  gaTracking,
  brandingLogo,
}) => {
  const linkWithVRM = getRedirectLinkWithVRM(redirectLink);

  const submitAction = (clickedButton) => {
    if (gaTracking) addTracking(gaTracking, clickedButton);
    redirectPage(linkWithVRM);
  };

  const startNow = useMemo(() => Date.now(), []);
  const [now, setNow] = useState(startNow);

  const secondsPassed = ((now - startNow) / 1000);

  useEffect(() => {
    const timer = secondsPassed <= redirectTimeSecs && setInterval(() => setNow(Date.now()), 1000);
    if (secondsPassed > redirectTimeSecs) submitAction(false);
    return () => clearInterval(timer);
  }, [secondsPassed]);

  return (
    <div className={`${cssPrefix}__intermediarypage`}>
      <p className={`${cssPrefix}__intermediarypage-desc`}>{desc}</p>
      <div className={`${cssPrefix}__intermediarypage--logos`}>
        <Image {...brandingLogo} />
        <AnimatedChevrons />
        <Image {...partnerLogo?.image} />
      </div>
      <p className={`${cssPrefix}__intermediarypage-redirecttext`}>{redirectText}</p>
      <Button
        type="submit"
        variant=""
        label="Continue"
        srLabel="Continue"
        onClick={() => submitAction(true)}
      />
    </div>
  );
};

IntermediaryPage.defaultProps = {
  context: {},
  desc: '',
  partnerLogo: {},
  redirectText: '',
  redirectLink: '',
  redirectTimeSecs: 10,
  gaTracking: {},
  brandingLogo: {},
};

IntermediaryPage.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  desc: PropTypes.string,
  partnerLogo: PropTypes.shape(),
  redirectText: PropTypes.string,
  redirectLink: PropTypes.string,
  redirectTimeSecs: PropTypes.number,
  gaTracking: PropTypes.shape(),
  brandingLogo: PropTypes.shape(),
};

export default withPolaris(IntermediaryPage);
